import { FetchResult } from '@apollo/client/link/core'
import { MutationFunctionOptions } from '@apollo/client/react/types/types'
import { OperationVariables } from '@apollo/client/core'
import { ApolloError, QueryLazyOptions } from '@apollo/client'
import popupError from 'globals/popupError'

export type DoMutation<TResult, TVariables = OperationVariables> = (
  options?: MutationFunctionOptions<TResult, TVariables>
) => Promise<FetchResult<TResult>>;

export type DoLazyQuery<TVariables> = (options?: QueryLazyOptions<TVariables>) => void;

export const hasNoError = <T>(ifNoError: (result: T) => void) => (response: FetchResult<T>) => {
  if (response?.data && !(response.data as any).error) {
    ifNoError(response.data)
  }
}

export const displayErrors = {
  onCompleted: (data?: any) => {
    if (data && data.error) popupError(data.error.message)
  },
  onError: (apolloError?: ApolloError) => {
    if (apolloError && apolloError.graphQLErrors) {
      apolloError.graphQLErrors.forEach((error) => popupError(error.message))
    } else if (apolloError && apolloError.networkError) {
      popupError(apolloError.networkError.message)
    }
  }
}
